import { __assign } from 'tslib';
import React__default from 'react';
import { Wrapper } from './Button.styles.js';
import { SIZES, THEMES } from './constants.js';

var Button = function Button(props) {
  return React__default.createElement(Wrapper, __assign({
    height: props.size && SIZES[props.size]
  }, props, props.theme ? THEMES[props.theme] : {}, {
    onClick: function onClick() {
      if (props.onClick) {
        props.onClick();
      }
    }
  }));
};

export { Button as default };